<template>
	<div
		v-for="(card, index) in cards"
		:key="index"
		class="horizontal-media-card display-flex flex-direction-column-reverse-smo gap-300-lg gap-150-md bg-color-white module-radius-lg"
	>
		<div class="horizontal-media-card-content col-6-md">
			<div>
				<h3 class="heading-2" v-html="card.title"></h3>
				<p v-for="(desc, descId) in card.description" :key="descId" v-html="desc"></p>
			</div>
			<p v-if="card.link" class="mt-100">
				<BaseCtaLink :link="card.link" :icon="card.link.target === '_blank' ? 'external-link' : 'arrow'" />
			</p>
		</div>
		<div v-reveal:fade-up role="figure" class="col-6-md flex-1">
			<img v-lazy="card.imageUrl" :alt="card.imageAlt" class="horizontal-media-card-image" />
		</div>
	</div>
</template>
<script lang="ts">
export default {
	name: 'InfoCardsHorizontalMedia'
};
</script>
<script setup lang="ts">
import { InfoCard } from 'types/layout';
interface Props {
	cards: Array<InfoCard>;
}
defineProps<Props>();
</script>

<style lang="scss" scoped>
@use '../../styles/utilities/respond-to.scss' as *;

.horizontal-media-card {
	@include respond-to(md) {
		gap: 64px;
	}

	@include respond-to(lg) {
		gap: 144px;
	}

	&-content {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		flex: 1;
		padding: 36px 24px;
		@include respond-to(md) {
			padding: 48px 0 48px 48px;
		}
	}

	&-image {
		height: 100%;
		border-radius: 8px 8px 0 0;
		@include respond-to(smo) {
			object-fit: cover;
			object-position: center;
			max-height: 203px;
		}
		@include respond-to(md) {
			border-radius: 0 8px 8px 0;
		}
	}
}
</style>
